
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.42 5.434a.75.75 0 011.055-.105l5 4.09a.75.75 0 010 1.162l-5 4.09a.75.75 0 01-.95-1.16L10.815 10l-4.29-3.51a.75.75 0 01-.105-1.056z","clip-rule":"evenodd"}})])
          )
        }
      }
    